<template>
  <CardRegist></CardRegist>
  <div class="usage-history">
    <h1 class="app-page-tit">카드 사용 내역</h1>
    <div class="scroll-tab-area">
      <div class="app-tab-wrap">
        <button type="button" class="tab on">전체</button>
        <button type="button" class="tab">결제</button>
        <button type="button" class="tab">취소</button>
      </div>
    </div>

    <div class="day-item">
      <span class="date">26. 01. 12(월)</span>
      <ul class="inr-list">
        <li>
          <div class="row left">
            <span class="time">오후 3:30</span>
            <div class="info">
              <span>결제취소</span>
              <span class="line"></span>
              <span>현대카드404*</span>
            </div>
          </div>
          <div class="row right">
            <strong class="amount delect">14,000원</strong>
          </div>
        </li>
        <li>
          <div class="row left">
            <span class="time">오후 3:30</span>
            <div class="info">
              <span>크레딧 구매</span>
              <span class="line"></span>
              <span>현대카드404*</span>
            </div>
          </div>
          <div class="row right">
            <strong class="amount">14,000원</strong>
          </div>
        </li>
      </ul>
    </div>

    <div class="day-item">
      <span class="date">26. 01. 11(일)</span>
      <ul class="inr-list">
        <li>
          <div class="row left">
            <span class="time">오후 3:30</span>
            <div class="info">
              <span>월간구독</span>
              <span class="line"></span>
              <span>현대카드404*</span>
            </div>
          </div>
          <div class="row right">
            <strong class="amount">14,000원</strong>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick } from 'vue';

import CardRegist from '@/components/domains/mobile/CardRegist.vue';

const currentTab = ref('korea');
const tabs = [
  { label: '한국 카드', value: 'korea' },
  { label: '해외 카드', value: 'oversea' },
];

const btnRefs = ref([]);

const horizStyle = ref({
  width: '0px',
  left: '0px',
});

// 위치 계산 및 이동 함수
const moveHoriz = (index) => {
  const btn = btnRefs.value[index];
  if (!btn) return;

  horizStyle.value = {
    width: `${btn.offsetWidth}px`,
    left: `${btn.offsetLeft}px`,
  };
};

// 탭 선택 핸들러
const selectTab = (index, value) => {
  currentTab.value = value;
  moveHoriz(index);
};

// 초기 로딩 시 위치 잡기
onMounted(async () => {
  await nextTick();
  // 초기 활성화된 탭의 인덱스를 찾아서 배경 이동
  const activeIndex = tabs.findIndex((t) => t.value === currentTab.value);
  moveHoriz(activeIndex !== -1 ? activeIndex : 0);
});

const emit = defineEmits(['close']);
const isOpen = ref(false);

// 닫기 로직
const handleClose = () => {
  //먼저 클래스를 제거해서 퇴장 애니메이션 실행
  isOpen.value = false;

  setTimeout(() => {
    emit('close');
  }, 300);
};

onMounted(() => {
  document.body.style.overflow = 'hidden';

  setTimeout(() => {
    isOpen.value = true;
  }, 10);
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>
<style scoped lang="scss">
.usage-history {
  padding-top: 2.5rem;
  h1 {
    margin-bottom: 0.75rem;
  }
  .day-item {
    margin-top: 1.5rem;
    .date {
      display: block;
      font-size: $font-size-xxs;
      margin-bottom: 0.5rem;
    }
    .inr-list {
      border-top: 1px solid $color-gray-900;
      li {
        border-bottom: 1px solid $color-gray-40;
        padding: 1rem 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .row {
          &.left {
            margin-bottom: 0.5rem;
            .info {
              display: flex;
              align-items: center;
              gap: $size-xs;
              span {
                &.line {
                  width: 1px;
                  height: 10px;
                  background: $color-gray-900;
                }
              }
            }
            span {
              display: block;
              font-size: $font-size-xs;
              &.time {
                color: $color-gray-100;
                display: block;
                margin-bottom: $size-s;
              }
            }
          }
          &.right {
            font-weight: 600;
            .amount {
              &.delect {
                color: $new-warning;
              }
            }
          }
        }
      }
    }
  }
}
</style>
